if (!customElements.get('product-comparison')) {
  class ProductComparison extends HTMLElement {
    constructor() {
      super();
      this.scrollContainer = this.querySelector('.comparison__scroll');
      this.dotsContainer = this.querySelector('.comparison__dots'); // scroll dışında
      this.columns = this.querySelectorAll('.comparison__column');
      this.dots = [];
    }

    connectedCallback() {
      if (!this.scrollContainer || this.columns.length === 0) return;

      this.buildDots();
      this.scrollContainer.addEventListener('scroll', this.onScroll.bind(this), { passive: true });
      window.addEventListener('resize', this.onResize.bind(this), { passive: true });

      // Images may not be loaded yet — wait before equalizing
      if (document.readyState === 'complete') {
        this.setColumnWidth();
        this.equalizeRows();
      } else {
        window.addEventListener('load', () => {
          this.setColumnWidth();
          this.equalizeRows();
        }, { once: true });
      }
    }

    setColumnWidth() {
      if (window.innerWidth >= 768) return;
      const grid = this.scrollContainer.querySelector('.comparison__grid');
      if (!grid) return;
      // Scroll container'ın gerçek genişliği (padding dahil)
      const scrollWidth = this.scrollContainer.offsetWidth;
      const gap = 8;
      const paddingH = 12; // grid padding her iki yan
      const colWidth = Math.floor((scrollWidth - gap - paddingH * 2) / 2);
      grid.style.setProperty('--col-width', colWidth + 'px');
    }

    buildDots() {
      if (!this.dotsContainer) return;
      this.dotsContainer.innerHTML = '';
      this.dots = [];

      this.columns.forEach((_, i) => {
        const dot = document.createElement('button');
        dot.classList.add('comparison__dot');
        dot.setAttribute('aria-label', 'Ürün ' + (i + 1));
        if (i === 0) dot.classList.add('is-active');
        dot.addEventListener('click', () => this.scrollToColumn(i));
        this.dotsContainer.appendChild(dot);
        this.dots.push(dot);
      });
    }

    scrollToColumn(index) {
      const col = this.columns[index];
      if (!col) return;
      const scrollLeft = col.offsetLeft - this.scrollContainer.offsetLeft - 16;
      this.scrollContainer.scrollTo({ left: scrollLeft, behavior: 'smooth' });
    }

    onScroll() {
      if (!this.dots.length) return;
      const scrollLeft = this.scrollContainer.scrollLeft;
      const containerOffset = this.scrollContainer.offsetLeft;
      let closest = 0;
      let minDist = Infinity;

      this.columns.forEach((col, i) => {
        const dist = Math.abs(col.offsetLeft - containerOffset - scrollLeft - 16);
        if (dist < minDist) {
          minDist = dist;
          closest = i;
        }
      });

      this.dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === closest);
      });
    }

    equalizeRows() {
      this.resetRowHeights();
      this.matchRowHeights();
    }

    onResize() {
      this.setColumnWidth();
      this.equalizeRows();
    }

    resetRowHeights() {
      this.querySelectorAll('.comparison__feature, .comparison__custom-text, .comparison__product-name, .comparison__product-price').forEach(el => {
        el.style.minHeight = '';
      });
    }

    matchRowHeights() {
      const featureRows = this.getRowGroups();
      featureRows.forEach(group => {
        let maxHeight = 0;
        group.forEach(el => {
          el.style.minHeight = '';
          maxHeight = Math.max(maxHeight, el.offsetHeight);
        });
        group.forEach(el => {
          el.style.minHeight = maxHeight + 'px';
        });
      });
    }

    getRowGroups() {
      const columnsArr = Array.from(this.columns);
      if (columnsArr.length === 0) return [];

      const firstCol = columnsArr[0];
      const cells = firstCol.querySelectorAll('[data-row]');
      const groups = [];

      cells.forEach(cell => {
        const rowId = cell.getAttribute('data-row');
        const group = columnsArr.map(col => col.querySelector('[data-row="' + rowId + '"]')).filter(Boolean);
        if (group.length > 0) groups.push(group);
      });

      return groups;
    }
  }

  customElements.define('product-comparison', ProductComparison);
}
